/* tslint:disable */
/* eslint-disable */
/**
 * Survey API
 * API for managing Surveys and Questions.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddPossibleAnswerCommand,
  CreateQuestionCommand,
  OperationResponse,
  PossibleAnswersResponse,
  QuestionDetailResponse,
  QuestionListResponse,
  ReorderQuestionsCommand,
  UpdatePossibleAnswerCommand,
  UpdateQuestionCommand,
} from '../models/index';
import {
    AddPossibleAnswerCommandFromJSON,
    AddPossibleAnswerCommandToJSON,
    CreateQuestionCommandFromJSON,
    CreateQuestionCommandToJSON,
    OperationResponseFromJSON,
    OperationResponseToJSON,
    PossibleAnswersResponseFromJSON,
    PossibleAnswersResponseToJSON,
    QuestionDetailResponseFromJSON,
    QuestionDetailResponseToJSON,
    QuestionListResponseFromJSON,
    QuestionListResponseToJSON,
    ReorderQuestionsCommandFromJSON,
    ReorderQuestionsCommandToJSON,
    UpdatePossibleAnswerCommandFromJSON,
    UpdatePossibleAnswerCommandToJSON,
    UpdateQuestionCommandFromJSON,
    UpdateQuestionCommandToJSON,
} from '../models/index';

export interface AddPossibleAnswerRequest {
    questionId: string;
    addPossibleAnswerCommand: AddPossibleAnswerCommand;
}

export interface CreateQuestionRequest {
    createQuestionCommand: CreateQuestionCommand;
}

export interface DeletePossibleAnswerRequest {
    questionId: string;
    answerId: string;
}

export interface DeleteQuestionRequest {
    id: string;
}

export interface GetQuestionByIdRequest {
    id: string;
}

export interface GetQuestionPossibleAnswersRequest {
    questionId: string;
}

export interface GetQuestionsRequest {
    questionnaireId: string;
    step?: number;
    questionType?: string;
    activeOnly?: boolean;
}

export interface ReorderQuestionsRequest {
    reorderQuestionsCommand: ReorderQuestionsCommand;
}

export interface UpdatePossibleAnswerRequest {
    questionId: string;
    answerId: string;
    updatePossibleAnswerCommand: UpdatePossibleAnswerCommand;
}

export interface UpdateQuestionRequest {
    id: string;
    updateQuestionCommand: UpdateQuestionCommand;
}

/**
 * 
 */
export class QuestionsApi extends runtime.BaseAPI {

    /**
     * Add a possible answer to a question
     */
    async addPossibleAnswerRaw(requestParameters: AddPossibleAnswerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['questionId'] == null) {
            throw new runtime.RequiredError(
                'questionId',
                'Required parameter "questionId" was null or undefined when calling addPossibleAnswer().'
            );
        }

        if (requestParameters['addPossibleAnswerCommand'] == null) {
            throw new runtime.RequiredError(
                'addPossibleAnswerCommand',
                'Required parameter "addPossibleAnswerCommand" was null or undefined when calling addPossibleAnswer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/questions/{questionId}/reponses-possibles`.replace(`{${"questionId"}}`, encodeURIComponent(String(requestParameters['questionId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddPossibleAnswerCommandToJSON(requestParameters['addPossibleAnswerCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Add a possible answer to a question
     */
    async addPossibleAnswer(requestParameters: AddPossibleAnswerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.addPossibleAnswerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new question
     */
    async createQuestionRaw(requestParameters: CreateQuestionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['createQuestionCommand'] == null) {
            throw new runtime.RequiredError(
                'createQuestionCommand',
                'Required parameter "createQuestionCommand" was null or undefined when calling createQuestion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/questions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateQuestionCommandToJSON(requestParameters['createQuestionCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Create a new question
     */
    async createQuestion(requestParameters: CreateQuestionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.createQuestionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a possible answer
     */
    async deletePossibleAnswerRaw(requestParameters: DeletePossibleAnswerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['questionId'] == null) {
            throw new runtime.RequiredError(
                'questionId',
                'Required parameter "questionId" was null or undefined when calling deletePossibleAnswer().'
            );
        }

        if (requestParameters['answerId'] == null) {
            throw new runtime.RequiredError(
                'answerId',
                'Required parameter "answerId" was null or undefined when calling deletePossibleAnswer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/questions/{questionId}/reponses-possibles/{answerId}`.replace(`{${"questionId"}}`, encodeURIComponent(String(requestParameters['questionId']))).replace(`{${"answerId"}}`, encodeURIComponent(String(requestParameters['answerId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Delete a possible answer
     */
    async deletePossibleAnswer(requestParameters: DeletePossibleAnswerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.deletePossibleAnswerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a question
     */
    async deleteQuestionRaw(requestParameters: DeleteQuestionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteQuestion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/questions/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Delete a question
     */
    async deleteQuestion(requestParameters: DeleteQuestionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.deleteQuestionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get question details by ID
     */
    async getQuestionByIdRaw(requestParameters: GetQuestionByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<QuestionDetailResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getQuestionById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/questions/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => QuestionDetailResponseFromJSON(jsonValue));
    }

    /**
     * Get question details by ID
     */
    async getQuestionById(requestParameters: GetQuestionByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<QuestionDetailResponse> {
        const response = await this.getQuestionByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get possible answers for a question
     */
    async getQuestionPossibleAnswersRaw(requestParameters: GetQuestionPossibleAnswersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PossibleAnswersResponse>> {
        if (requestParameters['questionId'] == null) {
            throw new runtime.RequiredError(
                'questionId',
                'Required parameter "questionId" was null or undefined when calling getQuestionPossibleAnswers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/questions/{questionId}/reponses-possibles`.replace(`{${"questionId"}}`, encodeURIComponent(String(requestParameters['questionId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PossibleAnswersResponseFromJSON(jsonValue));
    }

    /**
     * Get possible answers for a question
     */
    async getQuestionPossibleAnswers(requestParameters: GetQuestionPossibleAnswersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PossibleAnswersResponse> {
        const response = await this.getQuestionPossibleAnswersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get list of questions for a questionnaire
     */
    async getQuestionsRaw(requestParameters: GetQuestionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<QuestionListResponse>> {
        if (requestParameters['questionnaireId'] == null) {
            throw new runtime.RequiredError(
                'questionnaireId',
                'Required parameter "questionnaireId" was null or undefined when calling getQuestions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['questionnaireId'] != null) {
            queryParameters['questionnaireId'] = requestParameters['questionnaireId'];
        }

        if (requestParameters['step'] != null) {
            queryParameters['step'] = requestParameters['step'];
        }

        if (requestParameters['questionType'] != null) {
            queryParameters['questionType'] = requestParameters['questionType'];
        }

        if (requestParameters['activeOnly'] != null) {
            queryParameters['activeOnly'] = requestParameters['activeOnly'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/questions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => QuestionListResponseFromJSON(jsonValue));
    }

    /**
     * Get list of questions for a questionnaire
     */
    async getQuestions(requestParameters: GetQuestionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<QuestionListResponse> {
        const response = await this.getQuestionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Reorder questions
     */
    async reorderQuestionsRaw(requestParameters: ReorderQuestionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['reorderQuestionsCommand'] == null) {
            throw new runtime.RequiredError(
                'reorderQuestionsCommand',
                'Required parameter "reorderQuestionsCommand" was null or undefined when calling reorderQuestions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/questions/reorder`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReorderQuestionsCommandToJSON(requestParameters['reorderQuestionsCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Reorder questions
     */
    async reorderQuestions(requestParameters: ReorderQuestionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.reorderQuestionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a possible answer
     */
    async updatePossibleAnswerRaw(requestParameters: UpdatePossibleAnswerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['questionId'] == null) {
            throw new runtime.RequiredError(
                'questionId',
                'Required parameter "questionId" was null or undefined when calling updatePossibleAnswer().'
            );
        }

        if (requestParameters['answerId'] == null) {
            throw new runtime.RequiredError(
                'answerId',
                'Required parameter "answerId" was null or undefined when calling updatePossibleAnswer().'
            );
        }

        if (requestParameters['updatePossibleAnswerCommand'] == null) {
            throw new runtime.RequiredError(
                'updatePossibleAnswerCommand',
                'Required parameter "updatePossibleAnswerCommand" was null or undefined when calling updatePossibleAnswer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/questions/{questionId}/reponses-possibles/{answerId}`.replace(`{${"questionId"}}`, encodeURIComponent(String(requestParameters['questionId']))).replace(`{${"answerId"}}`, encodeURIComponent(String(requestParameters['answerId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePossibleAnswerCommandToJSON(requestParameters['updatePossibleAnswerCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Update a possible answer
     */
    async updatePossibleAnswer(requestParameters: UpdatePossibleAnswerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.updatePossibleAnswerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a question
     */
    async updateQuestionRaw(requestParameters: UpdateQuestionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateQuestion().'
            );
        }

        if (requestParameters['updateQuestionCommand'] == null) {
            throw new runtime.RequiredError(
                'updateQuestionCommand',
                'Required parameter "updateQuestionCommand" was null or undefined when calling updateQuestion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/questions/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateQuestionCommandToJSON(requestParameters['updateQuestionCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Update a question
     */
    async updateQuestion(requestParameters: UpdateQuestionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.updateQuestionRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
